import styled from 'styled-components';

export const FooterContainer = styled.div`
  flex-shrink: 0;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: center;
  padding: 0.75rem 1rem;
  z-index: 10;
  position: relative;
`;
